<script>
import RbxRemoteCombobox from '@/shared/reybex/RbxRemoteCombobox';
import RbxTextEditor from '@/shared/reybex/RbxTextEditor';
import validatorMixin from '@/mixins/validator';

export default {
  name: 'AffiliateContactPersonDialog',
  components: {
    RbxRemoteCombobox,
    RbxTextEditor,
  },
  mixins: [validatorMixin],
  props: {
    isCreateMode: {
      type: Boolean,
      default: false,
    },
    contactPerson: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      states: ['', 'Baden-Württemberg', 'Bayern', 'Berlin', 'Brandenburg', 'Bremen', 'Hamburg', 'Hessen',
        'Mecklenburg-Vorpommern', 'Niedersachsen', 'Nordrhein-Westfalen', 'Rheinland-Pfalz', 'Saarland',
        'Sachsen', 'Sachsen-Anhalt', 'Schleswig-Holstein', 'Thüringen'],
      visible: false,
      rules: {
        firstname: { required: true },
        surname: { required: true },
      },
      formData: {},
      defaultOptions: {

      },
    };
  },
  created() {
    this.formData = Object.assign({}, this.defaultOptions, this.contactPerson);
  },
  mounted() {
    this.visible = true;
  },
  methods: {
    submit() {
      const { formData, isCreateMode } = this;
      this.$emit('submit', { formData, isCreateMode });
      this.close();
    },
    close() {
      this.visible = false;
      this.$emit('cancel');
    },
  },
};
</script>

<template>
  <v-dialog v-model="visible"
            persistent
            max-width="1000px">

    <v-card>
      <v-card-title class="title pa-3">
        <span v-if="isCreateMode">Neuer Ansprechpartner</span>
        <span v-else>
          {{ contactPerson.firstname }} {{ contactPerson.surname }}
        </span>
      </v-card-title>

      <v-card-text>
        <v-container grid-list-md class="pa-0">
          <v-layout row wrap>
            <v-flex md12 xs12>
              <h4 class="affiliate-detail-tab-title">Allgemein</h4>
              <v-layout row wrap>

                <v-flex md4 py-0>
                  <rbx-remote-combobox
                    height="22"
                    class="caption"
                    v-model="formData.salutation"
                    label="Anrede"
                    :selected="formData.salutation"
                    domain="salutation"
                  />
                </v-flex>

                <v-flex md4 py-0>
                  <v-text-field
                    height="22"
                    class="caption"
                    v-model="formData.firstname"
                    :error-messages="validationErrorMessages.firstname"
                    label="Vorname"
                  />
                </v-flex>

                <v-flex md4 py-0>
                  <v-text-field
                    height="22"
                    class="caption"
                    v-model="formData.surname"
                    :error-messages="validationErrorMessages.surname"
                    label="Nachname"
                  />
                </v-flex>

                <v-flex md4 py-0>
                  <v-text-field
                    height="22"
                    class="caption"
                    v-model="formData.street"
                    label="Straße"
                  />
                </v-flex>

                <v-flex md4 py-0>
                  <v-text-field
                    height="22"
                    class="caption"
                    v-model="formData.zip"
                    label="PLZ"
                  />
                </v-flex>

                <v-flex md4 py-0>
                  <v-text-field
                    height="22"
                    class="caption"
                    v-model="formData.location"
                    label="Ort"
                  />
                </v-flex>

                <v-flex md4 py-0>
                  <v-text-field
                    height="22"
                    class="caption"
                    v-model="formData.country"
                    label="Land"
                  />
                </v-flex>

                <v-flex md4 py-0>
                  <v-combobox
                    v-model="formData.state"
                    :items="states"
                    label="Bundesland"
                    height="22"
                    domain="affiliateType"
                    class="caption"
                  />
                </v-flex>

                <v-flex xs12 md12>
                  <rbx-text-editor
                    label="Kommentar"
                    v-model="formData.comment"
                  />
                </v-flex>

              </v-layout>

              <h4 class="affiliate-detail-tab-title">Kontaktdaten</h4>
              <v-layout row wrap>

                <v-flex md4 py-0>
                  <v-text-field
                    height="22"
                    class="caption"
                    v-model="formData.phone"
                    label="Telefon"
                  />
                </v-flex>

                <v-flex md4 py-0>
                  <v-text-field
                    height="22"
                    class="caption"
                    v-model="formData.phone2"
                    label="Telefon 2"
                  />
                </v-flex>

                <v-flex md4 py-0>
                  <v-text-field
                    height="22"
                    class="caption"
                    v-model="formData.mobile"
                    label="Handy"
                  />
                </v-flex>

                <v-flex md4 py-0>
                  <v-text-field
                    height="22"
                    class="caption"
                    v-model="formData.fax"
                    label="Fax"
                  />
                </v-flex>

                <v-flex md4 py-0>
                  <v-text-field
                    height="22"
                    class="caption"
                    v-model="formData.email"
                    label="E-Mail-Adresse"
                  />
                </v-flex>

                <v-flex md4 py-0>
                  <v-text-field
                    height="22"
                    class="caption"
                    v-model="formData.web"
                    label="Webseite"
                  />
                </v-flex>

              </v-layout>

              <v-layout v-if="!isCreateMode" row wrap>

                <v-flex md2 py-0>
                  <v-switch
                    height="22"
                    class="caption"
                    v-model="formData.isActive"
                    label="Aktiv"
                  />
                </v-flex>

                <v-flex md2 py-0>
                  <v-switch
                    height="22"
                    class="caption"
                    v-model="formData.isDelete"
                    label="Gelöscht"
                  />
                </v-flex>

              </v-layout>

            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>

      <v-card-actions>
        <v-spacer/>
        <v-btn @click.native="close"
               color="red darken-1"
               class="js-cancel-button"
               flat>
          Schließen
        </v-btn>
        <v-btn @click.native="submit"
               class="js-submit-button"
               color="blue darken-1"
               flat>
          {{ isCreateMode ? 'Erstellen': 'Aktualisieren' }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
